import { AiChatInput } from "#models/AiChat"
import { ConditionAssistReply, ConfiguratorId } from "#models/Configurator"
import { S, TaggedRequestFor } from "../../lib.ts"
import { ConfiguratorConditionGroupInput, OptionConditionInput } from "./ConditionGroup.ts"

// codegen:start {preset: meta, sourcePrefix: src/resources/ }
const Req = TaggedRequestFor("Admin/Configurator/ConditionAi")
// codegen:end

// A Command, not a Query: the call is billable and must never be cached or
// replayed. Auth is the Admin default. Takes the editor DRAFT, not the saved group.
export class ExplainConfiguratorConditionGroup extends Req.Command<ExplainConfiguratorConditionGroup>()(
  "ExplainConfiguratorConditionGroup",
  {
    configuratorId: ConfiguratorId,
    conditionGroup: ConfiguratorConditionGroupInput
  },
  { success: S.Struct({ explanation: S.String }) }
) {}

export const AssistOp = S.Union([
  S.Struct({ op: S.Literal("append"), block: OptionConditionInput }),
  S.Struct({
    op: S.Literal("replace"),
    index: S.Int,
    block: OptionConditionInput
  }),
  S.Struct({ op: S.Literal("remove"), index: S.Int })
])
export type AssistOp = typeof AssistOp.Type

// A Command: billable, never cached or replayed. Works on the editor DRAFT.
export class AssistConditionGroup extends Req.Command<AssistConditionGroup>()("AssistConditionGroup", {
  configuratorId: ConfiguratorId,
  conditionGroup: ConfiguratorConditionGroupInput,
  ...AiChatInput.fields
}, {
  success: S.Struct({ reply: ConditionAssistReply, ops: S.Array(AssistOp) })
}) {}
